var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 57 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.22 17.47c.023.325.023.65.023.979C43.243 28.458 35.623 40 21.691 40v-.006A21.44 21.44 0 0 1 10.08 36.6q.897.108 1.802.11a15.2 15.2 0 0 0 9.407-3.249 7.58 7.58 0 0 1-7.076-5.26 7.55 7.55 0 0 0 3.42-.13 7.575 7.575 0 0 1-6.077-7.425v-.096a7.5 7.5 0 0 0 3.438.948 7.584 7.584 0 0 1-2.344-10.114 21.5 21.5 0 0 0 15.61 7.913 7.583 7.583 0 0 1 12.908-6.909 15.2 15.2 0 0 0 4.811-1.838 7.6 7.6 0 0 1-3.33 4.19A15 15 0 0 0 47 13.545a15.4 15.4 0 0 1-3.78 3.924"
  })));
};
export default SvgTwitter;